import React from 'react';
import type { CartItemType } from '@zola-helpers/client/dist/es/@types/cart';
import cx from 'classnames';

import styles from '../cartItemAttributes.module.less';

export const CardItemAttributeList = ({
  className,
  attributes,
}: {
  attributes: {
    label?: string | null;
    value?: string | null | React.ReactNode;
    className?: string;
  }[];
  className?: string;
}) => {
  return (
    <div className={cx(styles.cartItemAttributes, className)}>
      {attributes.map((attr) => (
        <div key={attr.label} className={attr.className}>
          <span className={styles.label}>{attr.label}:</span>{' '}
          <span className={styles.value}>{attr.value}</span>
        </div>
      ))}
    </div>
  );
};
export const CardItemAttributes = ({ item }: { item: CartItemType }) => {
  const itemAttributes = item.attributes || [];

  return <CardItemAttributeList attributes={itemAttributes} />;
};
